export default "__VITE_ASSET__DOT1n$ev__"